.container {
  max-height: calc(100vh - var(--mirai-ui-space-L) * 4);
  min-height: calc(var(--mirai-ui-space-L) * 4.75);
  overflow-y: auto;
}

.iframe,
.redirecting {
  border: none;
  display: block;
  height: calc(var(--mirai-ui-space-XXL) * 10);
  min-height: 0;
  width: 100%;
}

.iframe.hide {
    display: none;
}

.redirecting {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--mirai-ui-space-M);
  padding: var(--mirai-ui-space-L);
}
